import type { RouteRecordRaw } from 'vue-router'

export const devicesRoutes: RouteRecordRaw[] = [
  {
    name: 'devices',
    path: '/devices',
    component: () => import('@/modules/devices/views/DevicesView.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
